
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
    marginBottom:'25px',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
    width:'50%'
  },
  input_button:{
    marginRight:'4px'
  },

  item_body: {
    padding: '6px ',
    width:'100%'
  },
  venue_list: {
    padding: '6px',
    width: '100%',
    position: 'absolute',
    top: '30px',
    backgroundColor: 'white',
    zIndex: 999,
    border: '1px solid grey'
  },
  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
    marginTop:'1%'
  },
  sub_header: {
    borderBottom:'2px solid',
    textAlign:'left',
    fontSize:'20px',
    fontWeight:'bold',
    marginBottom:'15px',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '100%',
  },
  button_view:{
    paddingTop:'25px',
    paddingRight:'40px',
    textAlign:"right"
  },
  team_image : {
   width: '25px',
   height: '25px',
   borderRadius: '50%',
   marginRight: '5px',
   marginBottom:'5px',
 },
 team_list_dropdown:{
    position:'absolute',
    top: '100%',
    left: '2%',
    backgroundColor: 'white',
    border: '1px solid green',
    width: '96%',
    maxHeight: '250px',
    overflowY: 'auto',
    zIndex:999,
 },
 selected_team_box:{
    float: 'left',
    display: 'flex',
    border: '1px solid green',
    width: '74%',
    padding: '5px 5px'
 },
 selected_team_name:{
    width:'100%',
    alignItems: 'center',
    display: 'flex',
 },
 selected_team_name_close:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
 },
  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeam/style.js